import { $el } from 'src/scripts/utils/utils'
import { BaseComponent } from '../../components/base-component'
import { CarouselComponent } from '../../components/carousel/carousel'
import { isMobile } from 'src/scripts/utils/check-media'

const CAROUSEL_SELECTOR = `[data-product-media-carousel-component]`

export class ProductMediaCarousel extends BaseComponent {
  mountComponent(): void {
    this.setReady()
  }

  updateFirstMediaByVariant(imageId: string, jump = false): void {
    const carousel: CarouselComponent = $el(CAROUSEL_SELECTOR, this)

    if (imageId && carousel) {
      const slides = carousel.embla.slideNodes()
      const slideIndex = slides.findIndex(slide => {
        if (!slide.dataset.mediaId) {
          return false
        }
        return +slide.dataset.mediaId === +imageId
      })

      const isTwoColumnsCarousel =
        this.closest('.quick-view--drawer .quick-view--two-columns') &&
        !isMobile()

      if (isTwoColumnsCarousel) {
        const index = slideIndex % 2 === 0 ? slideIndex : slideIndex - 1
        carousel.embla.scrollTo(index, jump)
      } else {
        carousel.embla.scrollTo(slideIndex, jump)
      }
    }
  }

  setReady(): void {
    this.setAttribute('ready', '')
  }
}
